module.exports = __webpack_public_path__ + "img/section2.9f8340f2.svg";